module.exports = __webpack_public_path__ + "img/2.ac472bc5.jpg";